module.exports = __webpack_public_path__ + "img/kechengzixun.6b8a4e7c.png";